import { InjectionToken } from "@angular/core";

export const ROUTE_PATHS = {
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  LOGOUT: 'logout',
};
export const CODE_CHALLENGE_NAME: string = 'code';
export const REDIRECT_PATH_NAME: string = 'path';
export const MESSAGE_PARAM_NAME = 'message';
export const RESET_PASSWORD_TOKEN_PARAM_NAME = 'token';

export const API_URL_TOKEN = new InjectionToken('Api url token');
export const ENV_TOKEN = new InjectionToken('Active env token');
